import React, { Component } from "react";
import { connect } from "react-redux";

import ConstData from "../../lib/ConstData";
import { enWebPage } from "../../lib/ConstCommand";
import { enTokenCMD } from "../../lib/classTalk/CodeEnum";
import { isWindowsWebView, sendToStudentApp, hasIOSStudentAppBridge } from "../../lib/func/ExportFunction";
import { get_local_info } from "../../lib/api/local";

import {
    stopHandsUpMode,
    changeViewKind,
    changeMyCamViewInput,
    changeHandsUpVideoInput,
    updateReconnMode,
    setHandsUpMicOn,
    setHandsUpMicOff,
    setIsMixedClassMember,
    setHandsUpMicStatus,
    isIOSWebView,
    getIsForPblModeBrowser
} from "../../lib/HandsUpClient";

import {
    setVolume
} from "../../lib/MediaSoupClient";

import {
    disconnectLive,
    disconnectLiveForMixedLogin,
    disconnectLiveForQRLogin,
    sendClassMonitorUserScreenMode,
    sendGroupSmartTVMax,
    sendPresentationStudentRequest,
    setCurrentPageType,
    xmitCmd_AndroidMessage,
    xmitCmd_IosMessage
} from "../../lib/RabbitmqClient";

import { initClassMonitorScreenStateProc } from "../../lib/rbmq/rcvMsgFromRbmq";

import {
    changeDrawingMode,
    changeToolColor,
    changeToolThick,
    undoDrawingStroke,
    redoDrawingStroke,
    clearDrawingCanvas,
    mqSendInkStroke,
    changePerformLiveOffsetValue,
    setUndoStatus,
    setRedoStatus,
    setDrawingStatus,
    undoRedoSuccess,
    clickElement
} from "../../modules/classTalkLive";

import {
    finishLive,
    finishMyBroadcastLive,
    handsUpOn,
    handsUpOff,
    toggleIsNeedGoToHome,
    toggle_showWatchLiveMember,
    requestFinishMixedClassLive
} from "../../modules/live";

import ClassTalkContainer from "./classTalk/ClassTalkContainer";

import LiveMediaSoupRcv from "../../components/live/performLiveLayer/LiveMediaSoupRcv";
import LiveDrawingCanvas from "../../components/live/performLiveLayer/LiveDrawingCanvas";
import LiveDrawingTool from "../../components/live/performLiveLayer/LiveDrawingTool";
import LiveBroadcastDateCount from "../../components/live/performLiveLayer/LiveBroadcastDateCount";
import LiveControlTool from "../../components/live/performLiveLayer/LiveControlTool";
import IntensiveAlertModal from "../../components/live/modal/IntensiveAlertModal";
import MediaSoupUnsupportedCodecModal from "../../components/live/MediaSoupUnsupportedCodecModal";
import MediaErrorBell from "../../components/live/MediaErrorBell"; // 20260904 재생 실패/통신 오류 누적 알림 벨 ... by claude

// 모바일인지 여부 판단용 변수
const isMobile = (navigator.userAgent.toLowerCase().indexOf("android") > -1 || navigator.userAgent.toLowerCase().indexOf("iphone") > -1 || (navigator.userAgent.toLowerCase().indexOf("macintosh") > -1 && navigator.maxTouchPoints > 2));

class PerformLiveContainer extends Component {

    // 260804 클래스 종료 요청과 componentWillUnmount의 중복 종료 처리를 방지한다.
    isLiveFinishRequested = false;

    state = {
        isUpdate                : false,

        classTalkVisibility     : "hidden",
        teacherViewVisibility   : "hidden",
        myCamViewVisibility     : "none",
        optionVisibility        : (ConstData.IS_LOCAL_VERSION ? "hidden" : "none"),
        publicClassVisibility   : (ConstData.IS_LOCAL_VERSION ? "flex" : "none"),
        /* viewKind                : this.props.cookies.get("viewKind") === undefined || this.props.cookies.get("viewKind") === "" ? 
                                  (ConstData.IS_LOCAL_VERSION || this.props.isMixedClassMember) ? 
                                  "SCREEN" : "CAMERA" : this.props.cookies.get("viewKind"), */
        viewKind                : "SCREEN",

        isFullScreenMode        : false,
        isRetryConnect          : false,
        isMyCamMode             : false,
        isChangeViewKind        : false,
        classMonitorScreenStates: {}, // 260803 모니터 화면별 확대 학생 JSON 상태를 보관한다.

        // [끝내기] 할 수 없음을 알려주기 위해 변수 추가 ... by hjkim
        isIntensiveAlertModalOpened : false, 
    }

    componentDidMount() {
        // 260803 ClassMonitor 회신을 기준으로 학생의 최대화/최소화 버튼 모드를 동기화한다.
        initClassMonitorScreenStateProc(information => {
            if (!information || Number(information.liveSeq) !== Number(this.props.performLiveInfo.liveSeq)) return;
            this.setState(current => ({
                classMonitorScreenStates: {
                    ...current.classMonitorScreenStates,
                    [information.screenSeq]: information.maximizedUserSeq
                }
            }));
        });
        if (this.props.isMixedClassMember) {
            setCurrentPageType(enWebPage.MixedClassLiveClassTalk);
        }

        setIsMixedClassMember(this.props.isMixedClassMember);

        // console.log(`PerformLiveContainer componentDidMount - viewKind[${this.state.viewKind}]`);
        changeViewKind(this.state.viewKind);

        // console.log("PerformLiveContainer DidMount() - onHandleCookies call");
        this.onHandleCookies("set", "liveSeq", this.props.performLiveInfo.liveSeq);
        this.onHandleCookies("set", "userID", this.props.userID);
        this.onHandleCookies("set", "userSeq", this.props.userSeq);
        this.onHandleCookies("set", "userNickname", this.props.userNickname);
        this.onHandleCookies("set", "viewKind", this.state.viewKind);
        // this.props.onHandleCookies("set", "viewKind", this.state.viewKind);

        // 모바일 & 펜톡 브라우저 PC버전 & PBL 모드가 아니면 add하도록 수정 ... by hjkim 20260626
        if (!isMobile && !isWindowsWebView() && !getIsForPblModeBrowser()) {
            window.addEventListener("beforeunload", this.onBeforeunload);
        } else {
            // 로그인이 성공했으면 Android App에 메시지 보내기
            if (this.props.isLoginYn === "Y") {
                if (window.onStudentLoginSuccess !== undefined) {
                    console.log("call window.onStudentLoginSuccess");
                    window.onStudentLoginSuccess();
                } else {
                    console.log("window.onStudentLoginSuccess is undefined");
                }

                // 260812 학생 앱(Windows Pentalk Browser / Android AndWebnote2606)에도 알린다. 아래 정의부 참고.
                this.sendProLoginInfoToStudentApp();

                // 260815 학생 앱에 이 학생의 수업 입장을 알린다. 아래 정의부 참고.
                this.sendLessonConnectToStudentApp();
            } else {
                console.log("this.props.isLoginYn === 'N'");
            }
        }
    }

    /**
     * 260812 학생 앱(Windows Pentalk Browser / Android AndWebnote2606)에 로그인한 학생과 교실을 알린다. 지우지 말 것.
     * 260918 Android 학생 앱에도 나간다 — PentalkAgentAndroid\docs\external\web-frontend-android-bridge-request-20260918.md §5-1.
     *
     * 학생 앱은 이 두 값을 즐겨찾기 파일(proBookmarks.json)에 저장하고, 연결 Agent가 그것으로
     * 교실 바인딩을 만든다. 안 보내면 Pro 학생 바인딩이 하나도 생기지 않아 학생 PC가 접속 상태를
     * 발행하지 않고, 선생님 화면에 학생 접속 상태가 아무것도 뜨지 않는다.
     *
     * ⚠️ 두 값 모두 "0 패딩 없는 10진수 문자열"이다 — "6", "1002"이고 "006"이 아니다.
     * 연결 Agent의 교실 바인딩 키가 이 문자열 자체라, 형식이 바뀌면 같은 교실이 다른 교실로
     * 보여 조용히 깨진다. 바꿀 일이 생기면 학생 앱·연결 Agent 쪽에 사전 통보가 필요하다.
     *
     * 요청: docs\external\Pro_학생연동_전달_20260812.md §1
     */
    sendProLoginInfoToStudentApp = () => {
        // 학생 앱이 아니면 get_local_info()까지 갈 일이 없다. Android는 window.AndroidLogin으로 가른다.
        // 261021 iOS 학생 앱도 받는다 — 푸시 토큰 등록에 userSeq 가 필요하다(iOS 요청 20261021 §5).
        if (!isWindowsWebView() && !window.AndroidLogin && !hasIOSStudentAppBridge()) return;

        const { userSeq } = this.props;
        if (userSeq === undefined || userSeq === null || userSeq < 0) {
            console.log("sendProLoginInfoToStudentApp - invalid userSeq[", userSeq, "]");
            return;
        }

        // localServerSeq는 이 페이지를 서빙한 로컬 서버에게 직접 묻는다. 학생 로그인 흐름에는
        // 스토어에 그 값이 없다 — hiclasstv.localServerSeq는 교사 로그인 흐름에서만 채워진다.
        // /local/localInfo는 8000·8001 양쪽에 등록되어 있어 포트 오버라이드가 필요 없다.
        get_local_info().then(response => {
            const serverSeq = response && response.data && response.data.serverInfo
                ? response.data.serverInfo.serverSeq
                : undefined;

            if (serverSeq === undefined || serverSeq === null || serverSeq < 0) {
                console.log("sendProLoginInfoToStudentApp - invalid serverSeq[", serverSeq, "]");
                return;
            }

            console.log("call sendToStudentApp({ kind: 'proLoginInfo' }).");
            sendToStudentApp({
                kind: "proLoginInfo",
                localServerSeq: String(serverSeq),
                userSeq: String(userSeq)
            });
        }).catch(error => {
            // 로컬 서버가 아닌 환경에는 이 엔드포인트가 없다. 그때는 그냥 보내지 않는다.
            console.log("sendProLoginInfoToStudentApp - get_local_info failed.", error);
        });
    }

    /**
     * 260815 학생 앱(Windows Pentalk Browser / Android AndWebnote2606)에 이 학생의 수업 입장을 알린다. 지우지 말 것.
     * 260918 Android 학생 앱에도 나간다 — PentalkAgentAndroid\docs\external\web-frontend-android-bridge-request-20260918.md §5-2.
     *
     * 학생 앱은 이 신호로 "수업 중" 상태를 세운다. 안 보내면 (1) 이미 참여 중인 학생에게도 참여
     * 확인 팝업이 뜨고, (2) 이후 자동 로그인 요청이 조용히 무시되어 그 학생만 안 들어온다.
     * 둘 다 오류가 남지 않는다.
     *
     * ⚠️ "수업이 시작됐다"가 아니라 "이 학생이 들어갔다"인 지점에서만 보내야 한다. LIVE_ON 같은
     * 수업 시작 신호는 교실 전원에게 가므로, 아직 로그인 페이지에 있는 학생까지 "수업 중"이 되어
     * 그 교실의 자동 로그인이 통째로 죽는다. 여기(componentDidMount)는 그 학생의 라이브 화면이
     * 뜨는 시점이라 이 조건을 만족한다.
     *
     * 재입장 때도 보낸다 — 중복 수신은 앱이 멱등 처리한다. 응답은 없다(단방향).
     *
     * 계약: PentalkAgent\docs\external\web-to-student-app-disconnect-contract.md §3-0
     * 요청: PentalkAgent\docs\external\web-frontend-connect-message-request-20260815.md §3
     */
    sendLessonConnectToStudentApp = () => {
        console.log("call sendToStudentApp({ kind: 'connect' }).");
        sendToStudentApp({ kind: "connect" });
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log("======PerformLiveContainer-componentDidUpdate======");
        // console.log(`prevState.isUpdate[${prevState.isUpdate}] isUpdate[${this.state.isUpdate}]`);
        // console.log("======================================================");
        if (prevProps.isNeedGoToHome !== this.props.isNeedGoToHome && this.props.isNeedGoToHome === true) {
            console.log("PerformLiveContainer DidUpdate(3) - invalid liveSeq. go to web main page.");
            this.props.routeProps.history.push("/main");
            this.props.toggleIsNeedGoToHome(false);
        } else {
            if (prevProps.isGotoWebLive !== this.props.isGotoWebLive && this.props.isGotoWebLive === false) {
                /* if (this.props.userLoginPageType === enWebPage.Home) {
                    // console.log("PerformLiveContainer DidUpdate() - onHandleCookies call");
                    this.onHandleCookies("delete", "liveSeq", this.props.cookies.get("liveSeq"));
                    this.onHandleCookies("delete", "userID", this.props.cookies.get("userID"));
                    this.onHandleCookies("delete", "userSeq", this.props.cookies.get("userSeq"));
                    this.onHandleCookies("delete", "userNickname", this.props.cookies.get("userNickname"));
                    this.onHandleCookies("delete", "viewKind", this.props.cookies.get("viewKind"));

                    console.log("PerformLiveContainer DidUpdate() - go to web main page.");
                    this.props.routeProps.history.push("/main");
                } else if (this.props.userLoginPageType === enWebPage.LiveQRLogin) {
                    // console.log("PerformLiveContainer DidUpdate() - qrLiveInfo => ", this.props.qrLiveInfo);
                    if (this.props.qrLiveInfo && this.props.qrLiveInfo.liveSeq > 0) {
                        // console.log("PerformLiveContainer DidUpdate() - onHandleCookies call");
                        this.onHandleCookies("delete", "liveSeq", this.props.cookies.get("liveSeq"));
                        this.onHandleCookies("delete", "userID", this.props.cookies.get("userID"));
                        this.onHandleCookies("delete", "userSeq", this.props.cookies.get("userSeq"));
                        this.onHandleCookies("delete", "userNickname", this.props.cookies.get("userNickname"));
                        this.onHandleCookies("delete", "viewKind", this.props.cookies.get("viewKind"));

                        // console.log("PerformLiveContainer DidUpdate(1) - go to web qr login page.");
                        // this.props.routeProps.history.push(`/main-qrLogin/${this.props.qrLiveInfo.liveSeq}`);
                        // window.location.reload();
                        // window.location.replace(`/main-qrLogin/${this.props.qrLiveInfo.liveSeq}`);
                    } else {
                        if (ConstData.IS_LOCAL_VERSION) {
                            let liveSeq = Number(this.props.cookies.get("liveSeq"));
                            if (liveSeq > 0) {
                                console.log("PerformLiveContainer DidUpdate(2) - go to " + liveSeq + " live web qr login page with cookies.");
                                this.props.routeProps.history.push(`/main-qrLogin/${liveSeq}`);
                                window.location.reload();
                            } else {
                                // console.log("PerformLiveContainer DidUpdate() - onHandleCookies call");
                                this.onHandleCookies("delete", "liveSeq", this.props.cookies.get("liveSeq"));
                                this.onHandleCookies("delete", "userID", this.props.cookies.get("userID"));
                                this.onHandleCookies("delete", "userSeq", this.props.cookies.get("userSeq"));
                                this.onHandleCookies("delete", "userNickname", this.props.cookies.get("userNickname"));
                                this.onHandleCookies("delete", "viewKind", this.props.cookies.get("viewKind"));

                                // 여러번 왔다갔다해서 쿠키가 지워진 케이스...
                                // local version 인 경우 1001 로 이동 ... by hjkim 20230403
                                console.log("PerformLiveContainer DidUpdate(2) - invalid liveSeq[", liveSeq, "] ... go to 1001 live web qr login page.");
                                this.props.routeProps.history.push("/main-qrLogin/1001");
                                // window.location.replace("/main-qrLogin/1001");
                                window.location.reload();
                            }
                        } else {
                            // console.log("PerformLiveContainer DidUpdate() - onHandleCookies call");
                            this.onHandleCookies("delete", "liveSeq", this.props.cookies.get("liveSeq"));
                            this.onHandleCookies("delete", "userID", this.props.cookies.get("userID"));
                            this.onHandleCookies("delete", "userSeq", this.props.cookies.get("userSeq"));
                            this.onHandleCookies("delete", "userNickname", this.props.cookies.get("userNickname"));
                            this.onHandleCookies("delete", "viewKind", this.props.cookies.get("viewKind"));

                            console.log("PerformLiveContainer DidUpdate(3) - go to web main page.");
                            this.props.routeProps.history.push("/main");
                            window.location.reload();
                        }
                    }
                } else if (this.props.userLoginPageType === enWebPage.MixedClassLogin) {
                    let path = "/mixed-login/";
                    if (getIsForPblModeBrowser()) {
                        path = "/pbl-mixed-login/"
                    }

                    if (this.props.mixedClassInfo.mixedClassSeq > 0) {
                        console.log("PerformLiveContainer DidUpdate(4) - go to web mixed login page.");
                        console.log(`case 2:) PerformLiveContainer DidUpdate(4) - ${path}${this.props.mixedClassInfo.mixedClassSeq}`);
                        this.props.routeProps.history.push(`${path}${this.props.mixedClassInfo.mixedClassSeq}`);
                        window.location.reload();
                    } else {
                        console.log("PerformLiveContainer DidUpdate(4-2) - mixedClassSeq[", this.props.mixedClassInfo.mixedClassSeq, "]");
                        console.log("PerformLiveContainer DidUpdate(4-2) - invalid mixedClassSeq ... go to web main page.");
                        this.props.routeProps.history.push("/main");
                        window.location.reload();
                    }
                } else {
                    console.log("PerformLiveContainer DidUpdate() - 이런 경우가 있나요?ㅁ? 어디로 가야 하나요..? 일단 메인으로 갈까나..");
                    this.props.routeProps.history.push("/main");
                    // window.location.reload();
                } */

                // 20260327 여기부터 수정 코드 ... by hjkim
                // 페이지 이동은 모두 rabbitmq 연결 코드 처리하는 부분에서 처리하므로 쿠키만 삭제
                console.log("PerformLiveContainer DidUpdate() - onHandleCookies call - this.props.userLoginPageType[", this.props.userLoginPageType, "]");
                this.onHandleCookies("delete", "liveSeq", this.props.cookies.get("liveSeq"));
                this.onHandleCookies("delete", "userID", this.props.cookies.get("userID"));
                this.onHandleCookies("delete", "userSeq", this.props.cookies.get("userSeq"));
                this.onHandleCookies("delete", "userNickname", this.props.cookies.get("userNickname"));
                this.onHandleCookies("delete", "viewKind", this.props.cookies.get("viewKind"));

                // 홈페이지에서 id/password 입력 후 클래스에 참여한 경우는 페이지를 이동해야 함
                if (this.props.userLoginPageType === enWebPage.Home) {
                    console.log("PerformLiveContainer DidUpdate() - go to web main page.");
                    this.props.routeProps.history.push("/main");
                }
            }
        }

        const { performLiveInfo, isMixedClassMember } = this.props;

        if (this.state.isUpdate && performLiveInfo.liveSeq === -1) {
            console.log("PerformLiveContainer DidUpdate() - go to main (for alone chatting).");
            this.props.routeProps.history.push("/main");
        }

        if (prevProps.performLiveInfo.handsUpYN !== performLiveInfo.handsUpYN && performLiveInfo.handsUpYN === "N") {
            if (ConstData.IS_LOCAL_VERSION || this.props.isMixedClassMember) { // local server이거나 mixed class member인 경우 viewKind 기본값은 screen ... by hjkim 20221007
                console.log("PerformLiveContainer DidUpdate() - setState and saveCookies SCREEN");
                this.setState({ viewKind: "SCREEN" });
                this.onHandleCookies("set", "viewKind", "SCREEN");
                // this.props.onHandleCookies("set", "viewKind", "SCREEN");
            } else { // cloud server인 경우 viewKind 기본값은 camera ... by hjkim 20221007
                console.log("PerformLiveContainer DidUpdate() - setState and saveCookies CAMERA");
                this.setState({ viewKind: "CAMERA" });
                this.onHandleCookies("set", "viewKind", "CAMERA");
                // this.props.onHandleCookies("set", "viewKind", "CAMERA");
            }
        }

        if (prevProps.isWhisperModalOpened !== this.props.isWhisperModalOpened && this.props.isWhisperModalOpened) {
            // this.setState({ classTalkVisibility: "visible" });
        }

        /* if (isMixedClassMember) {
            if (this.props.performLiveInfo.liveSeq > -1) {
                // console.log(`prevProps.performLiveInfo.mixedClassStatus[${prevProps.performLiveInfo.mixedClassStatus}], this.props.performLiveInfo.mixedClassStatus[${this.props.performLiveInfo.mixedClassStatus}]`);
                if (prevProps.performLiveInfo.mixedClassStatus !== this.props.performLiveInfo.mixedClassStatus && this.props.performLiveInfo.mixedClassStatus === "N") {
                    window.removeEventListener("beforeunload", this.onBeforeunload);
                    this.onHandleCookies("delete", "liveSeq", this.props.cookies.get("liveSeq"));
                    this.onHandleCookies("delete", "userID", this.props.cookies.get("userID"));
                    this.onHandleCookies("delete", "userSeq", this.props.cookies.get("userSeq"));
                    this.onHandleCookies("delete", "userNickname", this.props.cookies.get("userNickname"));
                    this.onHandleCookies("delete", "viewKind", this.props.cookies.get("viewKind"));

                    let path = "/mixed-login/";
                    if (getIsForPblModeBrowser()) {
                        path = "/pbl-mixed-login/"
                    }

                    if (this.props.mixedClassInfo.mixedClassSeq > 0) {
                        console.log("PerformLiveContainer DidUpdate(5) - go to web mixed login page.");
                        console.log(`case 3:) PerformLiveContainer DidUpdate(5) - ${path}${this.props.mixedClassInfo.mixedClassSeq}`);
                        this.props.routeProps.history.push(`${path}${this.props.mixedClassInfo.mixedClassSeq}`);
                        window.location.reload();
                    } else {
                        console.log("PerformLiveContainer DidUpdate(5-2) - mixedClassSeq[", this.props.mixedClassInfo.mixedClassSeq, "]");
                        console.log("PerformLiveContainer DidUpdate(5-2) - invalid mixedClassSeq ... go to web main page.");
                        this.props.routeProps.history.push("/main");
                        window.location.reload();
                    }
                }
            }
        } */
    }

    componentWillUnmount() {
        initClassMonitorScreenStateProc(null); // 260803 수업 화면 종료 후 상태 회신 콜백을 정리한다.
        const { userSeq, performLiveInfo, performHandsUpStatusInfo } = this.props;

        if (performLiveInfo.liveSeq > -1) { // live에 입장한 case by hjkim 20220609
            if (performLiveInfo.handsUpYN === "Y" && performHandsUpStatusInfo.connectStatus !== "disable") {
                console.log("PerformLiveContainer - need to call stopHandsUpMode");
                stopHandsUpMode(performLiveInfo.liveSeq, userSeq, false, true);
            }

            // 260815 학생 앱(Windows Pentalk Browser / Android AndWebnote2606)에 수업 퇴장을 알린다. 지우지 말 것.
            // 260918 Android 학생 앱에도 나간다 — PentalkAgentAndroid\docs\external\web-frontend-android-bridge-request-20260918.md §5-3.
            // onExitButtonClick() 안에도 같은 발신이 있으나(AndroidWebViewHelper.js) 그 함수는
            // 안드로이드용 진입점이고, LIVE_FINISH가 isIntensiveControlMode에서 조기 반환하면
            // 거기까지 가지 못한다. 여기는 세 page type이 공통으로 지나가는 실제 퇴장 지점이다.
            // 중복 수신은 무해하다 — 앱이 "수업 중이 아님"이면 로그만 남기고 무시한다.
            // 계약: PentalkAgent\docs\external\web-to-student-app-disconnect-contract.md §3-3
            console.log("call sendToStudentApp({ kind: 'disconnect', reason: 'user-exit' }).");
            sendToStudentApp({ kind: "disconnect", reason: "user-exit" });

            // 260804 LIVE_ON 여부와 관계없이 RabbitMQ를 정리하고 page type별 로그인 화면으로 이동한다.
            if (this.props.userLoginPageType === enWebPage.LiveQRLogin) {
                // let liveSeq = Number(this.props.cookies.get("liveSeq"));
                console.log("PerformLiveContainer - need to call disconnectLiveForQRLogin");
                disconnectLiveForQRLogin();
            } else if (this.props.userLoginPageType === enWebPage.MixedClassLogin) {
                console.log("PerformLiveContainer - need to call disconnectLiveForMixedLogin");
                disconnectLiveForMixedLogin();
            } else {
                console.log("PerformLiveContainer - need to call disconnectLive");
                disconnectLive();
            }

            this.handleSelectedLiveFunc({ selectedFunc: "LIVE_FINISH" });

            /* if (window.onExitButtonClick !== undefined) {
                console.log("call window.onExitButtonClick");
                window.onExitButtonClick();
            } else {
                console.log("window.onExitButtonClick is undefined");
            } */
        } else { // 나와의 채팅 or 강의참여인 case by hjkim 20220609
            this.handleSelectedLiveFunc({ selectedFunc: "GO_TO_HOME" });
        }
    }

    onHandleCookies = (kind, name, value) => {
        const { cookies } = this.props;
        // console.log(`onHandleCookies - kind[${kind}], name[${name}], value[${value}]`);

        let newDate = new Date(Date.now());

        if (kind === "set") {
            newDate.setHours(newDate.getHours() + 3);
        } else if (kind === "delete") {
            newDate.setDate(newDate.getDate() - 1);
        }

        cookies.set(name, value, { path: "/", expires: newDate });
    }

    onBeforeunload = (event) => {
        event.preventDefault();
        // event.returnValue = "";

        console.log("beforeunload");

        const { cookies } = this.props;
        let newDate = new Date(Date.now());
        newDate.setDate(newDate.getDate() - 1);
        cookies.set("liveSeq", cookies.get("liveSeq"), { path: "/", expires: newDate });
        cookies.set("userID", cookies.get("userID"), { path: "/", expires: newDate });
        cookies.set("userSeq", cookies.get("userSeq"), { path: "/", expires: newDate });
        cookies.set("viewKind", cookies.get("viewKind"), { path: "/", expires: newDate });
    }

    handleControlToolFunc = ({ target, value }) => {
        switch (target) {
            case "classTalkVisibility":
                this.setState({ classTalkVisibility: value });
                break;

            case "teacherViewVisibility":
                this.setState({ teacherViewVisibility: value });
                break;

            case "myCamViewVisibility":
                this.setState({ myCamViewVisibility: value });
                break;

            case "optionVisibility":
                this.setState({ optionVisibility: value });
                break;

            case "publicClassVisibility":
                this.setState({ publicClassVisibility: value });
                break;

            case "viewKind":
                this.setState({ viewKind: value });
                this.onHandleCookies("set", "viewKind", value);
                // this.props.onHandleCookies("set", "viewKind", value);
                break;

            case "isFullScreenMode":
                this.setState({ isFullScreenMode: value });
                break;

            case "isRetryConnect":
                this.setState({ isRetryConnect: false });
                break;

            default:
                break;
        }
    }

    handleSelectedLiveFunc = ({ selectedFunc, data }) => {
        const { userSeq, userNickname, performLiveInfo, performHandsUpStatusInfo } = this.props;
        const { classTalkVisibility, teacherViewVisibility, myCamViewVisibility, isFullScreenMode, optionVisibility, publicClassVisibility } = this.state;

        // console.log(selectedFunc);

        switch (selectedFunc) {
            case "LIVE_MENU":
                this.props.toggle_showWatchLiveMember();
                break;

            case "LIVE_FINISH":
                if (this.props.isIntensiveControlMode) {
                    console.log("LIVE_FINISH case 1 - isIntensiveControlMode is true...");
                    this.setState({ isIntensiveAlertModalOpened: true });
                    return;
                }

                // 260804 끝내기 클릭 후 unmount에서 같은 종료 요청이 다시 실행되지 않도록 한다.
                if (this.isLiveFinishRequested) {
                    console.log("LIVE_FINISH skipped - already requested");
                    return;
                }
                this.isLiveFinishRequested = true;

                // 모바일 & 펜톡 브라우저 PC버전 & PBL 모드가 아니면 remove하도록 수정 ... by hjkim 20260626
                if (!isMobile && !isWindowsWebView() && !getIsForPblModeBrowser()) {
                    window.removeEventListener("beforeunload", this.onBeforeunload);
                }

                if (performLiveInfo.liveSeq === -1) {
                    console.log("LIVE_FINISH case 2");
                    this.setState({ isUpdate: true });
                } else {
                    if (performLiveInfo.teacher_info.userSeq === userSeq) { // my broadcast live
                        console.log("LIVE_FINISH case 3");
                        xmitCmd_AndroidMessage("ct_FinishLive", enTokenCMD.NULL, { userSeq, userNickname });
                        xmitCmd_IosMessage("ct_FinishLive", { endedByTeacher: performLiveInfo.liveStatus === "N" });
                        this.props.finishMyBroadcastLive({ liveSeq: performLiveInfo.liveSeq, userSeq });
                    } else {
                        if (this.props.isMixedClassMember) {
                            console.log("LIVE_FINISH case 4");
                            // this.props.logOut({ userSeq, mode: "mixed-web", liveSeq: performLiveInfo.liveSeq, isClickLogout: true });
                            xmitCmd_AndroidMessage("ct_FinishLive", enTokenCMD.NULL, { userSeq, userNickname });
                            xmitCmd_IosMessage("ct_FinishLive", { endedByTeacher: performLiveInfo.liveStatus === "N" });
                            this.props.requestFinishMixedClassLive({
                                liveSeq: this.props.mixedClassInfo.liveSeq,
                                userSeq: this.props.userSeq,
                                // userSeq: this.props.mixedClassInfo.localStudentSeq,
                                mixedClassSeq: this.props.mixedClassInfo.mixedClassSeq
                            });

                            /* let path = "/mixed-login/";
                            if (getIsForPblModeBrowser()) {
                                path = "/pbl-mixed-login/"
                            }
                            console.log("PerformLiveContainer LIVE_FINISH - mixedClassSeq[", this.props.mixedClassInfo.mixedClassSeq, "]");
                            if (this.props.mixedClassInfo.mixedClassSeq > 0) {
                                console.log(`case 4:) PerformLiveContainer LIVE_FINISH - ${path}${this.props.mixedClassInfo.mixedClassSeq}`);
                                this.props.routeProps.history.push(`${path}${this.props.mixedClassInfo.mixedClassSeq}`);
                                window.location.reload();
                            } else {
                                console.log("case 4-2:) PerformLiveContainer LIVE_FINISH - invalid mixedClassSeq ... go to web main page.");
                                this.props.routeProps.history.push("/main");
                                window.location.reload();
                            } */
                        } else {
                            console.log("LIVE_FINISH case 5");
                            xmitCmd_AndroidMessage("ct_FinishLive", enTokenCMD.NULL, { userSeq, userNickname });
                            xmitCmd_IosMessage("ct_FinishLive", { endedByTeacher: performLiveInfo.liveStatus === "N" });
                            this.props.finishLive({ liveSeq: performLiveInfo.liveSeq, userSeq });
                        }
                    }

                    // ios webview인 경우에만 메시지 전송되도록 수정 ... by hjkim 20251017
                    // if (isIOSWebView()) {
                    //     xmitCmd_IosMessage("exit-live", enTokenCMD.NULL);
                    // }
                    updateReconnMode(false);

                    if (window.onExitButtonClick !== undefined) {
                        console.log("call window.onExitButtonClick");
                        window.onExitButtonClick();
                    } else {
                        console.log("window.onExitButtonClick is undefined");
                    }
                }
                break;

            case "GO_TO_HOME":
                // 모바일 & 펜톡 브라우저 PC버전 & PBL 모드가 아니면 add하도록 수정 ... by hjkim 20260626
                if (!isMobile && !isWindowsWebView() && !getIsForPblModeBrowser()) {
                    window.removeEventListener("beforeunload", this.onBeforeunload);
                }

                if (performLiveInfo.liveSeq === -1) {
                    this.setState({ isUpdate: true });
                } else {
                    if (performLiveInfo.teacher_info.userSeq === userSeq) { // my broadcast live
                        xmitCmd_AndroidMessage("ct_FinishLive", enTokenCMD.NULL, { userSeq, userNickname });
                        this.props.finishMyBroadcastLive({ liveSeq: performLiveInfo.liveSeq, userSeq });
                    } else {
                        if (this.props.isMixedClassMember) {
                            //this.props.logOut({ userSeq, mode: "mixed-web", liveSeq: performLiveInfo.liveSeq, isClickLogout: true });
                            xmitCmd_AndroidMessage("ct_FinishLive", enTokenCMD.NULL, { userSeq, userNickname });
                            window.location = "/main";
                        } else {
                            xmitCmd_AndroidMessage("ct_FinishLive", enTokenCMD.NULL, { userSeq, userNickname });
                            this.props.finishLive({ liveSeq: performLiveInfo.liveSeq, userSeq });
                        }
                    }
                    updateReconnMode(false);
                }
                break;

            ////////////////////////////////////////////////////////////////
            /////////////////////// Control Toolbar ////////////////////////
            ////////////////////////////////////////////////////////////////

            case "TOGGLE_CLASSTALK":
                if (classTalkVisibility === "visible") {
                    this.setState({ classTalkVisibility: "hidden" });
                } else {
                    this.setState({ classTalkVisibility: "visible" });
                }
                break;

            case "TOGGLE_TEACHER_VIEW":
                if (teacherViewVisibility === "visible") {
                    this.setState({ teacherViewVisibility: "hidden" });
                } else {
                    this.setState({ teacherViewVisibility: "visible" });
                }
                break;

            case "TOGGLE_MYCAM_VIEW":
                if (myCamViewVisibility === "flex") {
                    // this.setState({ myCamViewVisibility : "none" });
                    changeMyCamViewInput(this.props.performLiveInfo.liveSeq, this.props.userSeq, false);
                } else {
                    // this.setState({ myCamViewVisibility : "flex" });
                    changeMyCamViewInput(this.props.performLiveInfo.liveSeq, this.props.userSeq, true);
                }
                break;

            case "TOGGLE_OPTION_VIEW":
                if (optionVisibility === "flex") {
                    this.setState({ optionVisibility: "hidden" });
                } else {
                    this.setState({ optionVisibility: "flex" });
                }
                break;

            case "TOGGLE_PUBLIC_CLASS": {
                let performLiveSeq = this.props.performLiveInfo.liveSeq;
                let performLiveStatus = this.props.performLiveInfo.liveStatus;

                // 기존 프로세스대로 동작 ... by hjkim
                if (performLiveSeq >= 0 && performLiveStatus === "Y") {
                    if (publicClassVisibility === "flex") {
                        this.setState({ optionVisibility: "hidden", publicClassVisibility: "hidden" });
                        setVolume(1);
                    } else {
                        this.setState({ optionVisibility: "hidden", publicClassVisibility: "flex" });
                        setVolume(0);
                    }
                } else {
                    if (ConstData.IS_LOCAL_VERSION) {
                        this.setState({ optionVisibility: "hidden", publicClassVisibility: "flex" });
                        setVolume(0);
                    } else {
                        this.setState({ optionVisibility: "none", publicClassVisibility: "none" });
                    }
                }
            } break;

            case "TOGGLE_INTENSIVE_ALERT":
                this.setState({ isIntensiveAlertModalOpened: false });
                break;

            case "SEND_SMART_TV_MAX":
                this.setState({ optionVisibility: "hidden" });
                sendGroupSmartTVMax(this.props.performLiveInfo.liveSeq, this.props.userSeq);
                break;

            case "REQUEST_PRESENTATION_STUDENT":
                // 260728 교사 승인 후 학생 강의 화면에 확대되도록 별도 요청한다.
                this.setState({ optionVisibility: "hidden" });
                sendPresentationStudentRequest(this.props.performLiveInfo.liveSeq, this.props.userSeq);
                break;

            case "SET_CLASS_MONITOR_SCREEN_MODE":
                // 260803 학생은 모니터 회신 상태의 반대 목표를 JSON으로 명시해 요청한다.
                this.setState({ optionVisibility: "hidden" });
                sendClassMonitorUserScreenMode(this.props.performLiveInfo.liveSeq, this.props.userSeq, data.isMaximized);
                break;

            case "CHANGE_VIEW_SIZE":
                // this.setState({ isFullScreenMode: data });
                this.setState({ isFullScreenMode: !isFullScreenMode });
                break;

            case "CHANGE_VIEW_KIND":
                this.setState({ myCamViewVisibility: "none" });
                changeHandsUpVideoInput(this.props.performLiveInfo.liveSeq, this.props.userSeq);
                break;

            case "CHANGE_PROC_MIC":
                if (data) {
                    const { status } = data;
                    setHandsUpMicStatus(this.props.performLiveInfo.liveSeq, this.props.userSeq, status);
                }
                break;

            case "PROC_MIC":
                if (this.props.performHandsUpStatusInfo.micStatus === "off") {
                    setHandsUpMicOn(this.props.performLiveInfo.liveSeq, this.props.userSeq);
                } else if (this.props.performHandsUpStatusInfo.micStatus === "mute" || this.props.performHandsUpStatusInfo.micStatus === "listen")
                    setHandsUpMicOff(this.props.performLiveInfo.liveSeq, this.props.userSeq);
                break;

            case "PROC_CONN":
                if (this.props.performHandsUpStatusInfo.connectStatus === "disconnect") {
                    if (this.props.performLiveInfo.handsUpYN === "Y") {
                        this.setState({ isRetryConnect: true });
                    }
                }
                break;

            case "HANDS_UP":
                if (performLiveInfo.handsUpYN === "Y") {    // handsUp 모드일 때만 동작하도록...
                    if (performHandsUpStatusInfo.myHandsUpYN === "Y") {
                        this.props.handsUpOff({ teacherSeq: performLiveInfo.teacher_info.userSeq, liveSeq: performLiveInfo.liveSeq, userSeq, userNickname });
                    } else {
                        this.props.handsUpOn({ teacherSeq: performLiveInfo.teacher_info.userSeq, liveSeq: performLiveInfo.liveSeq, userSeq, userNickname });
                    }
                }
                break;

            case "MEDIA_ALERT":
                if (data !== undefined && data !== null) {
                    this.props.handleSelectedFunc({ selectedFunc: "OPEN_LIVE_MEDIA_ALERT", kind: data.kind, mediaDevice_info: data.mediaDevice_info });
                }
                break;

            default:
                this.props.handleSelectedFunc({ selectedFunc });
                break;
        }
    }

    handleSelectedDrawingToolFunc = ({ selectedFunc, data, tool, flag }) => {
        const { userSeq, userNickname } = this.props;
        const { performLiveInfo } = this.props;
        const { liveSeq } = performLiveInfo;

        switch (selectedFunc) {
            ////////////////////////////////////////////////////////////////
            /////////////////////// Drawing Canvas /////////////////////////
            ////////////////////////////////////////////////////////////////

            case "SEND_STROKE":
                // console.log("send stroke - ", data);
                this.props.mqSendInkStroke({ stroke: data, liveSeq, userSeq, userNickname });
                break;

            case "SET_OFFSET":
                this.props.changePerformLiveOffsetValue({ offset: data.offset, liveSeq, userSeq });
                break;

            case "CLEAR_SUCCESS":
                this.props.clearDrawingCanvas({ selectedFunc, liveSeq, userSeq });
                break;

            case "UNDO_STATUS":
                this.props.setUndoStatus(flag);
                break;

            case "REDO_STATUS":
                this.props.setRedoStatus(flag);
                break;

            case "UNDO_REDO_SUCCESS":
                this.props.undoRedoSuccess();
                break;

            ////////////////////////////////////////////////////////////////
            ////////////////////// Drawing Toolbar /////////////////////////
            ////////////////////////////////////////////////////////////////

            case "CHANGE_MODE":
                //console.log("change mode");
                this.props.changeDrawingMode({ selectedFunc, tool, liveSeq, userSeq });
                break;

            case "CHANGE_COLOR":
                this.props.changeToolColor({ selectedFunc, tool, liveSeq, userSeq });
                break;

            case "CHANGE_THICK":
                this.props.changeToolThick({ selectedFunc, tool, liveSeq, userSeq });
                break;

            case "CLEAR":
                this.props.clearDrawingCanvas({ selectedFunc, liveSeq, userSeq });
                break;

            case "UNDO":
                this.props.undoDrawingStroke({ selectedFunc, liveSeq, userSeq });
                break;

            case "REDO":
                this.props.redoDrawingStroke({ selectedFunc, liveSeq, userSeq });
                break;

            case "SET_DRAWING_STATUS":
                this.props.setDrawingStatus({ isDrawingInkStroke: data.isDrawingInkStroke, liveSeq, userSeq });
                break;

            default:
                break;
        }
    }

    render() {
        const { routeProps, isJoinLive } = this.props;
        const { isGuestYn, userSeq, userNickname, mySubDomainSeq } = this.props;
        const { joinLiveInfo, performLiveInfo, performLiveStatusInfo, performHandsUpStatusInfo, smallGroupInfo } = this.props;
        const { drawingMode, tipSize, tipColor, isClearInkStroke, rcvPath, rcvStroke, rcvStrokes, androidPenPath } = this.props;
        const { isUndo, isRedo, isPossibleUndo, isPossibleRedo } = this.props;

        return (
            <div id="live-area" className="live-entire-area">
                {/* 20260807 수업 수신 화면에서 지원하지 않는 영상 코덱을 중앙 모달로 안내한다. */}
                {/* 20261023 수업 내부의 기존 모달 하나로 송수신 안내를 통합한다. */}
                <MediaSoupUnsupportedCodecModal direction="all" />
                {/* 20260904 재생 실패/통신 오류는 팝업 없이 하단 툴바 위 벨 아이콘으로만 안내한다. */}
                <MediaErrorBell />
                <div className="live-layer-area">
                    <LiveMediaSoupRcv
                        isMixedClassMember={this.props.isMixedClassMember}
                        userSeq={userSeq}
                        userLoginPageType={this.props.userLoginPageType}
                        drawingMode={drawingMode}
                        performLiveInfo={performLiveInfo}
                        performLiveStatusInfo={performLiveStatusInfo}
                        performHandsUpStatusInfo={performHandsUpStatusInfo}
                        smallGroupInfo={smallGroupInfo}
                        teacherViewVisibility={this.state.teacherViewVisibility}
                        myCamViewVisibility={this.state.myCamViewVisibility}
                        isRbmqServerConnected={this.props.isRbmqServerConnected}
                        isReadyLiveConsume={this.props.isReadyLiveConsume}
                        isRetryConnect={this.state.isRetryConnect}
                        isFullScreenMode={this.state.isFullScreenMode}
                        viewKind={this.state.viewKind}
                        isGuestYn={isGuestYn}
                        broadcastOpenYN={joinLiveInfo.broadcastOpenYN}
                        isLiveGuestAlertModalOpened={this.props.isLiveGuestAlertModalOpened}
                        isLiveMixedAlertModalOpened={this.props.isLiveMixedAlertModalOpened}
                        handleSelectedLiveFunc={this.handleSelectedLiveFunc}
                        handleControlToolFunc={this.handleControlToolFunc}
                    />
                    <LiveDrawingCanvas
                        rcvPath={rcvPath}
                        androidPenPath={androidPenPath}
                        rcvStroke={rcvStroke}
                        rcvStrokes={rcvStrokes}
                        drawingMode={drawingMode}
                        tipSize={tipSize}
                        tipColor={tipColor}
                        isClearInkStroke={isClearInkStroke}
                        isMixedClassMember={this.props.isMixedClassMember}
                        isLiveMixedAlertModalOpened={this.props.isLiveMixedAlertModalOpened}
                        isGuestYn={isGuestYn}
                        isLiveGuestAlertModalOpened={this.props.isLiveGuestAlertModalOpened}
                        handleSelectedDrawingToolFunc={this.handleSelectedDrawingToolFunc}
                    />
                    <ClassTalkContainer
                        routeProps={routeProps}
                        isJoinLive={isJoinLive}
                        isGuestYn={isGuestYn}
                        isWhisperModalOpened={this.props.isWhisperModalOpened}
                        classTalkVisibility={this.state.classTalkVisibility}
                        userSeq={userSeq}
                        userNickname={userNickname}
                        mySubDomainSeq={mySubDomainSeq}
                        broadcastOpenYN={joinLiveInfo.broadcastOpenYN}
                        performLiveInfo={performLiveInfo}
                        performLiveStatusInfo={performLiveStatusInfo}
                        performHandsUpStatusInfo={performHandsUpStatusInfo}
                        handleSelectedLiveFunc={this.handleSelectedLiveFunc}
                    />
                    <LiveDrawingTool
                        drawingMode={drawingMode}
                        isDrawingInkStroke={this.props.isDrawingInkStroke}
                        isPossibleUndo={isPossibleUndo}
                        isPossibleRedo={isPossibleRedo}
                        handleSelectedDrawingToolFunc={this.handleSelectedDrawingToolFunc}
                    />
                    {
                        (joinLiveInfo && joinLiveInfo.liveSeq > 0 && joinLiveInfo.visibility === "visible") &&
                        <LiveBroadcastDateCount
                            broadcastDateTime={joinLiveInfo.broadcastDateTime}
                        />
                    }
                    {
                        this.state.isIntensiveAlertModalOpened &&
                        <IntensiveAlertModal
                            live_info={this.props.performLiveInfo}
                            isAlertModalOpened={this.state.isIntensiveAlertModalOpened}
                            handleSelectedFunc={this.handleSelectedLiveFunc}
                        />
                    }
                </div>
                <LiveControlTool
                    userNickname={userNickname}
                    performLiveInfo={performLiveInfo}
                    performLiveStatusInfo={performLiveStatusInfo}
                    performHandsUpStatusInfo={performHandsUpStatusInfo}
                    classTalkVisibility={this.state.classTalkVisibility}
                    teacherViewVisibility={this.state.teacherViewVisibility}
                    myCamViewVisibility={this.state.myCamViewVisibility}
                    optionVisibility={this.state.optionVisibility}
                    publicClassVisibility={this.state.publicClassVisibility}
                    isFullScreenMode={this.state.isFullScreenMode}
                    viewKind={this.state.viewKind}
                    isClassMonitorMaximized={Object.values(this.state.classMonitorScreenStates).some(userSeq => Number(userSeq) === Number(this.props.userSeq))}
                    handleSelectedLiveFunc={this.handleSelectedLiveFunc}
                />
            </div>
        );
    }
}

export default connect(
    ({ user, live, classTalkLive, hiclasstv }) => ({ 
        isGuestYn                   : user.isGuestYn,
        isLoginYn                   : user.isLoginYn,

        userSeq                     : user.userSeq,
        userID                      : user.userID,
        userNickname                : user.userNickname,
        mySubDomainSeq              : user.mySubDomainSeq,

        userLoginPageType           : user.userLoginPageType,

        isRbmqServerConnected       : user.isRbmqServerConnected,

        isNeedGoToHome              : live.isNeedGoToHome,
        isGotoWebLive               : live.isGotoWebLive,

        joinLiveInfo                : live.joinLiveInfo,
        performLiveStatusInfo       : live.performLiveStatusInfo,
        performHandsUpStatusInfo    : live.performHandsUpStatusInfo,
        isMixedClassMember          : live.isMixedClassMember,
        mixedClassInfo              : live.mixedClassInfo,
        isReadyLiveConsume          : live.isReadyLiveConsume,

        smallGroupInfo              : live.smallGroupInfo,

        isIntensiveControlMode      : live.isIntensiveControlMode,

        drawingMode                 : classTalkLive.drawingMode,
        tipSize                     : classTalkLive.tipSize,
        tipColor                    : classTalkLive.tipColor,
        isUndo                      : classTalkLive.isUndo,
        isRedo                      : classTalkLive.isRedo,
        isClearInkStroke            : classTalkLive.isClearInkStroke,
        isDrawingInkStroke          : classTalkLive.isDrawingInkStroke,

        rcvPath                     : {
            rcvCmd                  : classTalkLive.rcvCmd,
            rcvMode                 : classTalkLive.rcvMode,
            rcvColor                : classTalkLive.rcvColor,
            rcvWidth                : classTalkLive.rcvWidth,
            rcvPoint1               : classTalkLive.rcvPoint1,
            rcvPoint2               : classTalkLive.rcvPoint2, 
        },
        rcvStroke                   : classTalkLive.rcvStroke,
        rcvStrokes                  : classTalkLive.rcvStrokes,

        androidPenPath              : classTalkLive.androidPenPath,

        performLiveImgViewSize      : classTalkLive.performLiveImgViewSize,

        isPossibleUndo              : classTalkLive.isPossibleUndo,
        isPossibleRedo              : classTalkLive.isPossibleRedo,

        isWhisperModalOpened        : classTalkLive.isWhisperModalOpened,

        qrLiveInfo                  : hiclasstv.qrLiveInfo,
    }),
    {
        toggleIsNeedGoToHome,
        toggle_showWatchLiveMember,

        handsUpOn, 
        handsUpOff,
        finishLive,
        finishMyBroadcastLive,

        changeDrawingMode,
        changeToolColor,
        changeToolThick,
        undoDrawingStroke,
        redoDrawingStroke,

        mqSendInkStroke,
        changePerformLiveOffsetValue,
        clearDrawingCanvas,
        setUndoStatus,
        setRedoStatus,
        setDrawingStatus,
        undoRedoSuccess,

        clickElement,
        requestFinishMixedClassLive
    }
)(PerformLiveContainer);
